<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal task">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <label>API </label>
          <select
            class="form-control"
            v-model="selectedAPI"
            @change="setActiveAPI"
          >
            <option
              v-for="api in APIList"
              :key="api.caption"
              :value="api.caption"
            >
              {{ api.caption }}
            </option>
          </select>
          <label v-if="selectedAPI">Paths</label>
          <select
            v-if="selectedAPI"
            class="form-control"
            v-model="selectedFunction"
            @change="renderResults"
          >
            <option v-for="f in activeAPI.functions" :key="f.index" :value="f">
              {{ f.name }} ({{ f.method }})
            </option>
          </select>

          <!-- Input -->
          <div class="results" v-if="activeFunction">
            <div v-for="(p, j) in activeFunction.parameters" :key="j">
              <template>
                <label for="p.name"
                  >{{ p.name }} <span v-if="p.required">*</span></label
                >
                <div class="input-wrap">
                  <div class="custom-dropdown w-100">
                    <template v-if="p.name !== 'item'">
                      <input type="text" :name="p.name" v-model="p.value" />
                      <b-icon-chevron-down></b-icon-chevron-down>
                    </template>
                    <template v-else>
                      <input
                        type="text"
                        :name="p.name"
                        v-model="userOrTaskInput"
                        :disabled="isUserInput"
                        @change="createCustomObject($event, p)"
                      />
                      <b-icon-chevron-down
                        :class="{ open: showDropDown }"
                        @click="toggleDropDown"
                      ></b-icon-chevron-down>
                      <ul class="form-control" v-show="showDropDown">
                        <li
                          @click="setTaskInput(input, p)"
                          v-for="input in task.input"
                          :key="input.id"
                        >
                          {{ input.name }}
                        </li>
                      </ul>
                      <div
                        class="remove-selected-option"
                        :class="{ open: isUserInput }"
                      >
                        <b-icon-x-circle-fill
                          :class="{ open: showDropDown }"
                          @click="toggleInput"
                        ></b-icon-x-circle-fill>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
            <button class="btn" @click="callAPI">Senden</button>
          </div>
          <!-- End Input -->

          <!-- Results -->
          <json-viewer :value="results" v-if="results"></json-viewer>
          <!-- End results-->

          <div class="tools">
            <div class="element" v-if="this.files.length > 0">
              <div class="button" @click.stop="toggleAttacheFile">
                <svg
                  width="18px"
                  height="18px"
                  x="0px"
                  y="0px"
                  viewBox="0 0 607.983 607.983"
                >
                  <g>
                    <g>
                      <path
                        d="M112.682,572.01c23.18,23.198,56.648,35.974,94.234,35.974c46.082,0,92.125-18.541,123.161-49.61L581.403,307.09
                        c0,0,6.152-6.942,6.152-16.92c0-13.517-10.957-24.471-24.469-24.471c-7.162,0-13.547,3.132-18.021,8.033L295.226,523.532
                        c-21.511,21.545-56.271,35.463-88.553,35.463c-17.036,0-41.119-3.792-59.14-21.836l-56.299-56.3
                        c-37.093-37.093-22.869-111.116,13.631-147.678l267.88-267.851c10.369-10.38,24.174-16.099,38.871-16.099
                        s28.5,5.718,38.871,16.104l47.402,47.363c21.404,21.473,21.404,56.352,0.004,77.753L272.668,415.644
                        c-13.646,13.67-28.435,21.19-41.654,21.19c-9.912,0-19.054-4.126-27.187-12.264c-9.95-9.955-9.95-17.088-9.95-32.714
                        c0-14.664,5.723-28.467,16.108-38.871L406.95,156.041c0,0,5.789-5.375,5.789-16.773c0-13.517-10.959-24.47-24.471-24.47
                        c-7.75,0-14.572,3.672-19.057,9.29L175.135,318.135c-19.679,19.713-30.523,45.896-30.542,73.718
                        c0,26.636,4.083,47.229,24.389,67.559c17.294,17.294,38.518,26.436,61.387,26.431c26.98,0,54.382-12.556,77.15-35.357
                        l225.227-225.187c40.648-40.646,40.648-106.79,0-147.444l-47.406-47.368C465.676,10.825,439.495,0,411.616,0
                        s-54.062,10.825-73.723,30.485L70.024,298.335c-31.054,31.021-49.596,77.059-49.596,123.161c0,37.59,12.771,71.054,35.955,94.214
                        L112.682,572.01z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="info-wrapper" v-show="!tools.attache.show">
                <div class="info">Datei anhängen</div>
              </div>
              <div
                class="toggle-list-wrapper files"
                v-if="tools.attache.show"
                v-click-outside="hideAttacheFile"
              >
                <div
                  v-for="(f, index) in files"
                  :key="index"
                  class="item"
                  :class="{ checked: f.selected }"
                >
                  <img class="logo" :src="getImgUrl('./file-icon.png')" />
                  <div class="label">{{ f.name }}</div>
                  <div class="check-box" @click="attacheFile(f)">
                    <svg width="26" height="15" class="icon">
                      <rect x="0" y="0" />
                      <g>
                        <g>
                          <rect
                            x="65.38988800054005"
                            y="111.28423827474339"
                            width="61.04743778705597"
                            height="237"
                            transform="matrix(0.027894680951674893,-0.02301867936171278,0.01967084489978093,0.0326421523831461,-4.013084678766421,5.249976641417972) "
                          />
                          <rect
                            x="305.0431614702238"
                            y="-96.1089254879951"
                            width="62.20270872116089"
                            height="558.1124589443208"
                            transform="matrix(0.01917799119807895,0.03304131945959807,-0.028235793207795276,0.022441945551370072,11.382479318709576,-7.922156200173908) "
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="element" v-if="this.dataFields.length > 0">
              <div class="button" @click.stop="toggleDataFields">
                <svg
                  width="24px"
                  height="24px"
                  x="0px"
                  y="0px"
                  viewBox="0 0 450 600"
                  class="data-fields"
                >
                  <g>
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      id="svg_20"
                      x="321.42857360839844"
                      y="328.7261941432953"
                      width="226"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="322.1230182647705"
                      y="327.4761941432953"
                      width="226"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_29"
                      transform="rotate(89.70001220703125 435.1231689453125,342.4761657714844) "
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="-0.17856436967849731"
                      y="233.25000143051147"
                      width="351.9325393145858"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_28"
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="0"
                      y="0.75"
                      width="403.32143771648407"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_32"
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="0"
                      y="117.03968334197998"
                      width="404.2142987717938"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_30"
                    />
                  </g>
                </svg>
              </div>
              <div class="info-wrapper" v-show="!tools.addDataField.show">
                <div class="info">Daten einfügen</div>
              </div>
              <div
                class="toggle-list-wrapper data-fields"
                v-if="tools.addDataField.show"
                v-click-outside="hideDataFields"
              >
                <div class="search">
                  <span class="search-icon"></span>
                  <input
                    name="search"
                    v-model="dataFieldFilter"
                    placeholder="Suchbegriff"
                  />
                </div>
                <div
                  v-for="(f, index) in filteredDataFields"
                  :key="index"
                  class="item"
                  @click="insertInputData(f.name)"
                >
                  <div class="label">{{ f.name }}</div>
                </div>
              </div>
            </div>
            <!--
              <div class="element">
                <div class="button" @click.stop="toggleActions">
                  <svg width="35px" height="35px" viewBox="0 0 199 450" class="action">
                    <g class="currentLayer" style>
                      <title>Layer 1</title>
                      <g id="svg_1" class>
                        <path
                          d="M202.03238457051327,73.5780002722473 C201.05229871341942,73.22957060707455 199.98126778537414,73.22957060707455 199.0011820184045,73.5780002722473 C196.6574603010755,74.4112153714122 195.43605627034424,76.97794178007808 196.27309972150658,79.31094411156698 L233.4149062230573,182.83235613657348 C233.90379718497138,184.19498889473732 235.02299107909062,185.23919363183165 236.42063969595768,185.63669554500586 C238.8135930712972,186.31726910928143 241.3077143878064,184.93798402208893 241.99141586718417,182.55597520144545 L255.47263839669085,135.58750073978467 C255.90035129650926,134.09735054274205 257.0705166949735,132.9325370827397 258.56751364682054,132.5067803962243 L305.7517929507146,119.08721639248114 C307.14944066634035,118.68971447930687 308.2686354617009,117.64550974221254 308.7575255223737,116.28287698404873 C309.5945696044049,113.94987420400017 308.3731650329289,111.38314851302977 306.02944376622054,110.54993278588131 L202.03238457051327,73.5780002722473 zM267.0956140156255,144.07659647861982 L254.9898920979772,186.25283889602247 C252.2550879829488,195.78087507571553 242.2786036181531,201.29801721872434 232.70678921555378,198.57572116738345 C227.11619537895444,196.98571441180582 222.6394186308637,192.80889636054792 220.68385595482113,187.3583644307733 L183.54204909277394,83.8369523160548 C180.19387528812456,74.50494307981114 185.0794914110494,64.23803762457146 194.45437819024136,60.90517713819992 C198.37472134824418,59.51145829808513 202.65884524067354,59.51145829808513 206.57918830855226,60.90517713819992 L310.57624759438374,97.87711001068169 C319.9511344636999,101.20997049705323 324.83675004587985,111.47687595229291 321.4885764214788,120.80888527824845 C319.5330143763051,126.25941720802314 315.0562369973455,130.43623525928103 309.4656425298772,132.02624201485872 L267.0956140156255,144.07659647861982 z"
                          id="svg_2"
                        />
                      </g>
                      <path
                        fill="none"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-width="14"
                        stroke-dasharray="none"
                        stroke-linejoin="miter"
                        stroke-linecap="butt"
                        stroke-dashoffset
                        fill-rule="nonzero"
                        opacity="1"
                        marker-start
                        marker-mid
                        marker-end
                        d="M67.22427,7.5212L232.33008,7C247.97018,7 261.11312,22.98174 261.11312,42L261.11312,88.93549C261.11312,107.95375 247.97018,123.93549 232.33008,123.93549L35.78304,123.93549C20.14294,123.93549 7,107.95375 7,88.93549L7,42"
                        id="svg_3"
                        class="selected"
                        transform="rotate(-179.8015899658203 134.0565490722656,65.46774291992186) "
                      />
                    </g>
                  </svg>
                </div>
                <div class="info-wrapper" v-show="tools.addAction.show">
                  <div class="info">Aktion verknüpfen</div>
                </div>
                <div
                  class="toggle-list-wrapper actions"
                  v-if="tools.addAction.show"
                  v-click-outside="hideActions"
                >
                  <div class="search">
                    <span class="search-icon"></span>
                    <input name="search" v-model="actionFilter" />
                  </div>
                  <div v-for="(a, index) in filteredActions" :key="index" class="item" @click="insertHTML(a.html)">
                    <div class="label">{{a.name}}</div>
                  </div>
                </div>
              </div>
              -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import RichText from "../widgets/RichText.vue";
// import button from "!raw-loader!../assets/files/html-button-for-email.txt";
//import Store from "../../store/store";
import JsonViewer from 'vue-json-viewer';

export default {
  name: 'API',
  data() {
    return {
      selectedAPI: null,
      selectedFunction: null,
      activeAPI: {
        functions: [],
      },
      activeFunction: null,
      itemInput: null,
      APIList: [
        {
          caption: 'Database/v3',
          name: 'data',
          url: 'https://data.api.codelos.io/v3',
          schemaUrl: 'https://data.api.codelos.io/v3/swagger.json',
          schema: null,
          functions: [],
          visibility: 'everyone',
        },
        {
          caption: 'Loadparser/v1',
          name: 'data',
          url: 'https://loadparser.api.codelos.io/v1',
          schemaUrl: 'https://loadparser.api.codelos.io/v1/swagger.json',
          schema: null,
          functions: [],
          visibility: 'everyone',
        },
        {
          caption: 'Loadparser/v3',
          name: 'data',
          urt: 'https://loadparser.api.codelos.io/v3',
          schemaUrl: 'https://data.api.codelos.io/v3/swagger.json',
          schema: null,
          functions: [],
          visibility: 'admin',
        },
        {
          caption: 'Mapper/v2',
          name: 'data',
          url: 'https://Load-mapper-power.api.codelos.1o/v2',
          schemaUrl: 'https://data.api.codelos.io/v3/swagger.json',
          schema: null,
          functions: [],
          visibility: 'none',
        },
      ],
      results: null,
      dataFieldFilter: null,
      actionFilter: null,
      activeInput: null,
      actions: [
        {
          name: 'Gutschrift beantragen',
          html: button,
        },
        {
          name: 'Gutschrift Bestätigen/Ablehnen',
          html: button,
        },
      ],
      tools: {
        attache: {
          show: false,
        },
        addDataField: {
          show: false,
        },
        addAction: {
          show: false,
        },
      },
      showDropDown: false,
      userOrTaskInput: null,
      isTaskInput: false,
      isUserInput: false,
    };
  },
  props: {
    task: Object,
    input: Array,
  },
  methods: {
    listFunctionsFromSchema: function (schema) {
      let functionList = [];
      let keys = Object.keys(schema.paths);
      let index = 0;
      for (let i = 0; i < keys.length; i++) {
        ['get', 'post', 'delete', 'put'].forEach((e) => {
          if (schema.paths[keys[i]].hasOwnProperty(e)) {
            functionList.push({
              index: index,
              name: keys[i],
              method: e,
              parameters: schema.paths[keys[i]][e].parameters || [],
            });

            if (functionList[functionList.length - 1].parameters) {
              functionList[functionList.length - 1].parameters.map((p) => {
                if (p === undefined) return;
                p.value = this.defaultValue(p.name);
                return p;
              });
            }
            index += 1;
          }
        });
      }
      functionList.map((e) => {
        if (
          e.parameters !== undefined &&
          schema.paths[e.name].parameters !== undefined
        ) {
          schema.paths[e.name].parameters.forEach((param) => {
            e.parameters.push(param);
          });
        }
      });
      return functionList;
    },
    setActiveAPI: async function () {
      this.activeAPI = this.APIList.find((i) => i.caption == this.selectedAPI);
      await fetch(this.activeAPI.schemaUrl)
        .then((response) => response.json())
        .then((data) => {
          this.activeAPI.schema = data;
        });
      this.activeAPI.functions = this.listFunctionsFromSchema(
        this.activeAPI.schema
      );
    },
    renderResults: function () {
      this.activeFunction = this.activeAPI.functions.find((e) => {
        return (
          e.name === this.selectedFunction.name &&
          e.method === this.selectedFunction.method
        );
      });
    },
    toggleDropDown: function () {
      this.showDropDown = !this.showDropDown;
    },

    setTaskInput: function (input, parameter) {
      this.isTaskInput = true;
      this.isUserInput = true;
      this.showDropDown = !this.showDropDown;
      this.activeFunction.parameters.map((e) => {
        if (e.name === parameter.name) {
          this.userOrTaskInput = input.name;
          e.value = input.value;
        }
      });
      this.$forceUpdate();
    },

    toggleInput() {
      this.isUserInput = false;
      this.userOrTaskInput = null;
    },
    createCustomObject: function (e, p) {
      if (!this.userOrTaskInput) this.isTaskInput = false;

      if (this.isTaskInput) e.preventDefault();

      let customObject = {
        id: this.getUuid(),
        value: this.userOrTaskInput,
        type: 'custom',
      };
      this.activeFunction.parameters.map((e) => {
        if (p.name === e.name) {
          e['value'] = customObject;
        }
      });
    },
    getUuid() {
      return new Date().getTime();
    },
    callAPI() {
      let url = this.activeAPI.url;

      let urlPaths = this.activeFunction.name.split('/');
      urlPaths.forEach((element, i) => {
        this.activeFunction.parameters.forEach((e) => {
          if (element === '{' + e.name + '}') {
            urlPaths[i] = e.value;
          }
        });
      });
      url += urlPaths.join('/');

      let myHeaders = new Headers();
      let headersParams = this.activeFunction.parameters.filter(
        (e) => e.in === 'header'
      );
      headersParams.forEach((header) => {
        myHeaders.append(header.name, header.value);
      });
      myHeaders.append('content-type', 'application/json');

      let formData = new FormData();

      let bodyParamsFormData = this.activeFunction.parameters.filter(
        (e) => e.in === 'formData'
      );

      bodyParamsFormData.forEach((param) => {
        formData.append(param.name, param.value);
      });

      let bodyParams = this.activeFunction.parameters.filter(
        (e) => e.in === 'query'
      );
      let requestContent = {
        headers: myHeaders,
        method: this.activeFunction.method,
      };
      if (this.activeFunction.method !== 'get') {
        formData.entries().next().value
          ? (requestContent['body'] = formData)
          : (requestContent['body'] = JSON.stringify(
              ...bodyParams.map((k) => ({ [k.name]: [k][0].value }))
            ));
      } else {
        let queryStringParams = {};
        bodyParams.forEach((k) => {
          if ([k][0].value) {
            queryStringParams[[k][0].name] = [k][0].value;
          }
        });

        if (Object.entries(queryStringParams).length !== 0) {
          url = `${url}?${new URLSearchParams(queryStringParams)}`;
        }
      }

      fetch(url, requestContent)
        .then((response) => {
          if (response.status == 401) {
            this.handleTokenExpired();
            this.results = 'Token Expired';
          } else return response.json();
        })
        .then((json) => {
          let outputResponse = {
            label: this.selectedFunction.name,
            name:
              this.selectedFunction.name + '_' + this.selectedFunction.method,
            value: json,
            type: 'Object',
          };
          this.task.output.push(outputResponse);
          this.results = json;
          this.loading = false;
          this.isUploadFileVisible = false;
        })
        .catch((e) => {
          this.loading = false;
          let errorResponse = {
            label: 'error',
            name: 'error',
            type: 'error',
            value: e,
          };
          this.results = e;
          this.task.output.push(errorResponse);
        });
    },
    handleTokenExpired: function () {
      localStorage.clear(),
        this.$router.push({
          name: 'auth',
          params: { message: 'Sitzung abgelaufen' },
        });
    },
    buildInputForm: function () {
      return null;
    },
    defaultValue: function (name) {
      // uncomment this.user.signIn
      return name == 'Authorization'
        ? 'Bearer ' + 'this.user.signInUserSession.accessToken.jwtToken'
        : null;
    },
    close: function () {
      this.$set(this.task, 'output', this.task.input);
      this.$emit('close');
    },
    getMessage: function () {
      if (this.task.props.message) return this.task.props.message;
      else return '<br>';
    },
    // getImgUrl: function(img) {
    //   var images = require.context("../assets/", false, /\.png$/);
    //   return images(img);
    // },
    showAttacheFile: function () {
      this.tools.attache.show = true;
    },
    hideAttacheFile: function () {
      this.tools.attache.show = false;
    },
    toggleAttacheFile: function () {
      this.tools.attache.show = !this.tools.attache.show;
      this.hideDataFields();
      this.hideActions();
    },
    hideDataFields: function () {
      this.tools.addDataField.show = false;
    },
    toggleDataFields: function () {
      this.tools.addDataField.show = !this.tools.addDataField.show;
      this.hideAttacheFile();
      this.hideActions();
    },
    hideActions: function () {
      this.tools.addAction.show = false;
    },
    toggleActions: function () {
      this.tools.addAction.show = !this.tools.addAction.show;
      this.hideDataFields();
      this.hideAttacheFile();
    },
    insertInputData: function (inputData) {
      if (this.activeInput == 'rich-text') this.insertText(inputData);
      else {
        let el = this.$refs[this.activeInput];
        let value = this.concatStrAtPosition(
          el.selectionStart,
          el.value,
          inputData
        );

        switch (this.activeInput) {
          case 'receiver':
            this.task.props.receiver = value;
            break;
          case 'cc':
            this.task.props.cc = value;
            break;
          case 'bcc':
            this.task.props.bcc = value;
            break;
          case 'subject':
            this.task.props.subject = value;
            break;
        }
      }
    },
    concatStrAtPosition: function (position, content, input) {
      return (
        content.slice(0, position) + '{' + input + '}' + content.slice(position)
      );
    },
    insertText: function (content) {
      let q = this.$refs['rich-text'].$refs['contant-editor'].quill;
      var selection = q.getSelection(true);
      var insertText = '{' + content + '}';
      q.insertText(selection.index, insertText);
    },
    insertHTML: function (content) {
      let oldContent = this.$refs['rich-text'].richContent;
      this.$refs['rich-text'].richContent = oldContent + content;
      //let q = this.$refs["rich-text"].$refs["contant-editor"].quill;
      //q.set
      /*
      let q = this.$refs["rich-text"].$refs["contant-editor"].quill;
      var selection = q.getSelection(true);
      q.clipboard.dangerouslyPasteHTML(selection.index, insertText);
      */
    },
    isAttached: function (file) {
      return (
        this.task.props.attachment.filter((f) => f.label == file.label).length >
        0
      );
    },
    addAttachment: function (file) {
      this.task.props.attachment.push({ label: file.name });
    },
    removeAttachment: function (name) {
      this.task.props.attachment = this.task.props.attachment.filter(
        (f) => f.label != name
      );
    },
    attacheFile: function (file) {
      if (file.selected) this.removeAttachment(file.name);
      else this.addAttachment(file);
      this.showAttacheFile();
    },
  },
  computed: {
    /*user() {
      return Store.state.user;
    },
    */
    dataFields() {
      let dataFields = [];
      this.task.input.forEach((e) => {
        if (
          e.type != 'file' &&
          !e.hasOwnProperty('isFromSettings') &&
          e.type != 'model'
        )
          dataFields.push({
            name: e.name,
          });
      });
      return dataFields;
    },
    filteredDataFields() {
      return this.dataFields.filter((f) => {
        if (this.dataFieldFilter)
          return (
            f.name.toLowerCase().indexOf(this.dataFieldFilter.toLowerCase()) >
            -1
          );
        else return this.dataFields;
      });
    },
    filteredActions() {
      return this.actions.filter((a) => {
        if (this.actionFilter)
          return (
            a.name.toLowerCase().indexOf(this.actionFilter.toLowerCase()) > -1
          );
        else return this.actions;
      });
    },
    files() {
      let files = [];
      this.task.input.forEach((e) => {
        if (e.type == 'file')
          files.push({
            name: e.name,
            selected: this.isAttached(e),
          });
      });
      return files;
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    //RichText,
    JsonViewer,
  },
};
</script>

<style scoped>
/*
@import "https://cdn.jsdelivr.net/npm/pretty-checkbox@3.0/dist/pretty-checkbox.min.css";
*/

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.tab {
  text-align: left;
  padding: 58px 40px;
  height: 100%;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  /*height: 400px*/
}

input,
select {
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  width: 100%;
}

.imput-group > input {
  width: 70%;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  margin-right: 15px;
  height: 10px;
}

.modal .btn-close {
  width: 13px;
  height: 13px;
}

button.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  left: 3px;
  position: relative;
  top: -153px;
  left: -18px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin: 0 18px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
/* .tabsLabels .url {
  background-image: url("../assets/img/modal-sprite.png");
  background-size: 1293px 1277px;
  background-position: -893px -1109px;
}

.tabsLabels .email {
  background-image: url("../assets/img/modal-sprite.png");
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .mscons {
  background-image: url("../assets/img/modal-sprite.png");
  background-size: 1293px 1277px;
  background-position: -828px -1175px;
}

.tabsLabels .system {
  background-image: url("../assets/img/modal-sprite.png");
  background-size: 1293px 1277px;
  background-position: -137px -1178px;
} */

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.pull-right.default {
  margin-top: 0;
}

.e-mail-params {
  height: 230px;
}

button {
  margin-top: 20px;
}

.form-group {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 0px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-bottom: 1px;
  border-bottom-style: solid;
  border-bottom-color: #dee0e4;
  margin-bottom: 0px;
}

.form-group .label {
  margin-top: 20px;
  text-transform: none;
}

.form-group input {
  width: 100%;
  border: 0;
  padding-bottom: 14px;
  padding-top: 18px;
}

input:focus {
  outline: none;
}

.element {
  margin-bottom: 16px;
}

:root {
  --color-pink: #f36;
  --color-pink-darker: #e81e61;
  --color-blue-lighter: #f5fbff;
  --color-blue: #276ee5;
  --color-blue-darker: #1f53d5;
  --color-green-lighter: #f2fbfa;
  --color-green: #09baa6;
  --color-green-darker: #00a08e;
  --color-yellow-lighter: #fffbf4;
  --color-yellow: #ffb631;
  --color-yellow-darker: #e8a01e;
  --color-red-lighter: #fdf3f5;
  --color-red: #e01e3d;
  --color-red-darker: #c60d2b;
  --color-ink-lightest: #9599a2;
  --color-ink-lighter: #6e7077;
  --color-ink: #22252b;
  --color-ink-darker: #17191d;
  --color-gray-lightest: #f8f8fa;
  --color-gray-lighter: #ebecee;
  --color-gray: #dee0e4;
  --color-gray-darker: #c7cad1;
  --color-black-lighter: #182237;
  --color-black: #15181f;
  --color-white: #fff;
  --elevation-low: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  --elevation-medium: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 5px 10px rgba(0, 0, 0, 0.15);
  --elevation-high: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 10px 20px rgba(0, 0, 0, 0.15);
  --rounded: 4px;
  --circled: 50%;
  --pilled: 64px;
}

.pretty {
  line-height: 36px;
}

.logo {
  width: 35px;
  margin-top: 24px;
}

.check-box {
  border-style: solid;
  height: 16px;
  width: 16px;
  position: relative;
  top: -127px;
  border-width: 1px;
  border-color: var(--color-black);
  left: 1px;
  background-color: #ffff;
  transition: all 0.3s ease-out;
  border-radius: 50%;
}

.check-box .icon {
  fill: #ffff;
  zoom: 0.6;
  padding-top: 6px;
  padding-left: 3px;
}

.item.checked .check-box {
  background-color: var(--color-black);
}

.search {
  width: 200px;
  padding: 5px 0 20px 0;
  height: 21px;
  margin-left: 12px;
  border-bottom: solid 1px #bdc3c7;
  margin-right: 12px;
  margin-bottom: 12px;
}

.search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 23px;
  overflow: hidden;
  display: block;
  width: 24px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
}

.search input {
  border: 0;
  width: 85%;
  margin-left: 5px;
  height: 15px;
  cursor: initial;
  padding-top: 11px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
}

.attachment {
  overflow: scroll;
  margin-right: 0;
  display: block;
  width: 300px;
  top: -400px;
  position: relative;
  height: 147px;
  margin-left: 0;
  float: right;
  text-align: right;
  cursor: auto;
}

.attachment .item {
  height: 135px;
  cursor: auto;
  padding: 8px;
  width: 75px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}

.attachment .item .label {
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  color: #596377;
}

.toggle-list-wrapper.data-fields .item .label {
  line-height: 41px;
}

#app.rich-text {
  height: calc(100% - 230px);
  overflow: scroll;
}

::v-deep .ql-editor {
  margin-top: 15px;
}

::v-deep .ql-toolbar.ql-snow {
  margin-top: -31px;
}

::v-deep .ql-toolbar.ql-snow {
  pointer-events: all;
  width: fit-content;
  flex-direction: row;
  flex-shrink: 0;
  box-shadow: var(--elevation-medium);
  background: #fff;
  z-index: 100;
  margin-left: auto;
  margin-right: auto;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,
    Arial, sans-serif, Inv Maison Neue, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  margin-top: -24px;
  z-index: 3;
  margin-bottom: 0px;
  position: fixed;
  left: 0;
  right: 0;
  border-radius: 6px;
  margin-top: -25px;
  height: 55px;
}

::v-deep .ql-container.ql-snow {
  border: none;
}

::v-deep .ql-toolbar.ql-snow .ql-formats {
  border: none;
  width: 132px;
  text-align: center;
  position: relative;
  padding-left: 8px;
  height: 40px;
  padding-top: 7px;
}

::v-deep .modal.task {
  max-width: 1147px;
  width: 70%;
}

/*custom dropdown*/
.input-wrap {
  position: relative;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}

.input-wrap input {
  margin-bottom: 0;
}

.custom-dropdown svg {
  position: absolute;
  right: 10px;
  z-index: 1;
  top: 18px;
  cursor: pointer;
  transition: all 300ms ease-in-out;
}

.custom-dropdown svg.open {
  transform: rotate(180deg);
}

.custom-dropdown ul {
  position: absolute;
  left: 0;
  top: calc(100% - 20px);
  list-style: none;
  background: #fff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 2px 4px rgb(0 0 0 / 30%);
  margin: 0;
  padding: 0;
  z-index: 2;
  width: 100%;
}

.custom-dropdown ul li {
  padding: 4px 15px;
  text-transform: capitalize;
  cursor: pointer;
  transition: all 300ms ease-in-out;
}

.custom-dropdown ul li:hover {
  background: #eee;
}

.remove-selected-option {
  position: absolute;
  right: 40px;
  top: 0;
  transform: translateY(-50%);
  color: #625f5f;
  z-index: 1;
  cursor: pointer;
  transition: all 300ms ease-in-out;
  opacity: 0;
  visibility: hidden;
}
.remove-selected-option.open {
  opacity: 1;
  visibility: visible;
}
.w-100 {
  width: 100%;
}
</style>
